module.exports = __webpack_public_path__ + "img/homekit-hubs.e5c002a2.jpg";